export interface ApiLeadTrackingGetResponse {
    leadId: string;
    leadUlid: string;
    awarenessLanding: string;
    awarenessSource: string;
    awarenessMedium: string;
    awarenessChannel: string;
    awarenessKeyword: string;
    awarenessCampaign: string;
    awarenessContent: string;
    goalLanding: string;
    goalSource: string;
    goalMedium: string;
    goalChannel: string;
    goalKeyword: string;
    goalCampaign: string;
    goalContent: string;
    oldCampaign: string;
    googleAnalyticsId: string;
    fullstoryId: string;
    vwoId: string;
    utmSource: string;
    utmMedium: string;
    utmCampaign: string;
    newCampaign: string;
    atGd: string;
    tid: string;
    utmContent: string;
    utmTerm: string;
    utmTest: string;
    fbclid: string;
    gclid: string;
    msclkid: string;
    utmEntryPage: string;
    utmReferrerUrl: string;
    aBTestVersion: string;
}

const apiLeadTrackingGet = async (
  leadId: string
): Promise<ApiLeadTrackingGetResponse[]> => {
  const response = fetch(
    `${process.env.REACT_APP_CUSTOMER_APP_URL}api/tracking/get/${leadId}`
  ).then((response) => response.json());

  return response;
};

export const getTrackingUtms = async (leadId: string) => {
  // El tracking vive en el monolito: un lead native no está ahí (lista vacía) y la
  // llamada puede fallar. Sin tracking → UTMs vacías; nunca debe cortar el login.
  let tracking: ApiLeadTrackingGetResponse[] = [];
  try {
    const response = await apiLeadTrackingGet(leadId);
    tracking = Array.isArray(response) ? response : [];
  } catch {
    tracking = [];
  }
  const last: Partial<ApiLeadTrackingGetResponse> = tracking[tracking.length - 1] ?? {};

  const utms = {
    utm_source: last.utmSource ?? null,
    utm_medium: last.utmMedium ?? null,
    utm_campaign: last.utmCampaign ?? null,
    utm_content: last.utmContent ?? null,
    utm_term: last.utmTerm ?? null,
    utm_test: last.utmTest ?? null,
    fbclid: last.fbclid ?? null,
    gclid: last.gclid ?? null,
    msclkid: last.msclkid ?? null,
    entryPage: last.utmEntryPage ?? null,
    referrerUrl: last.utmReferrerUrl ?? null,
    ABTestVersion: last.aBTestVersion ?? null
  };
  return utms;
};

export default apiLeadTrackingGet;
